import React from 'react';
import styled from 'styled-components';

import {
  getStrainTypePillBackground,
  getStrainTypePillTextColor,
  getStrainTypeColorKey,
  STRAIN_TYPE_CSS_SUFFIX,
} from '@dutchie/common/utils/strain-type-colors';
import { useCardContext } from './card-context';

/** Strain type pill (e.g. "Indica", "Sativa", "Hybrid"). Renders nothing when strainType is absent. */
export function CardStrainType(): JSX.Element | null {
  const { strainType } = useCardContext();

  if (!strainType) {
    return null;
  }

  return (
    <Pill data-testid='card-strain' $strainType={strainType}>
      {strainType}
    </Pill>
  );
}

const Pill = styled.div<{ $strainType: string }>`
  background: ${({ theme, $strainType }) => {
    const key = getStrainTypeColorKey($strainType);
    const fallback = getStrainTypePillBackground($strainType, theme.customized.colors.strainTypeColors);
    return key ? `var(--dcm-strain-type-pill-bg-${STRAIN_TYPE_CSS_SUFFIX[key]}, ${fallback})` : fallback;
  }};
  border-radius: 12px;
  color: ${({ theme, $strainType }) => {
    const key = getStrainTypeColorKey($strainType);
    const bg = getStrainTypePillBackground($strainType, theme.customized.colors.strainTypeColors);
    const fallback = getStrainTypePillTextColor(bg);
    return key ? `var(--dcm-strain-type-pill-text-${STRAIN_TYPE_CSS_SUFFIX[key]}, ${fallback})` : fallback;
  }};
  display: inline-block;
  font-family: ${({ theme }) => theme.customized.fonts.secondary};
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  padding: 6px 8px;
`;
